function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7515 44.1847C17.4414 41.5888 20.5941 40.7497 22.79 43.024C23.9664 44.2396 24.8762 45.2983 24.8056 47.0628C27.06 45.7074 29.5743 44.8416 32.1853 44.5219C34.2048 44.2446 36.2551 44.2816 38.2632 44.6317C37.4006 43.1024 37.5967 41.926 38.028 40.2713C38.8123 37.2127 42.208 36.35 45.8234 37.2676C49.4388 38.1851 51.3132 40.7497 50.5289 43.8082C49.9015 46.2159 48.7801 47.7922 45.6352 47.9569C48.8427 50.6894 51.0954 54.3734 52.066 58.4737H52.1131C52.568 60.1833 56.5285 59.603 60.0576 55.4151C60.4262 61.5715 55.4775 70.6452 42.459 75.0214C41.9178 75.2096 41.3611 75.3821 40.7808 75.5468L40.4749 75.6409H40.3808C39.0757 75.985 37.7503 76.2469 36.4124 76.4251C26.5387 77.7192 18.0375 75.0214 16.7278 65.03C16.2375 61.2741 16.8592 57.4568 18.5159 54.0505C16.32 54.4426 15.1044 53.3604 13.6849 51.886C11.4498 49.6195 12.0615 46.7648 14.7515 44.1847Z",
  fill: "#5C5096"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.1604 18.7278H74.9976C79.6927 18.7278 83.4989 22.5339 83.4989 27.2291V27.2369C83.4989 31.932 79.6927 35.7382 74.9976 35.7382H67.4584C65.6493 35.7439 65.1798 36.6035 64.6042 37.6576C64.3002 38.2142 63.9667 38.8249 63.3907 39.3928C61.7202 41.0397 58.7557 40.8201 59.2263 40.5142C60.6984 39.5903 60.4897 35.7502 57.7571 35.7382H50.1604C45.4653 35.7382 41.6592 31.932 41.6592 27.2369V27.2291C41.6592 22.5339 45.4653 18.7278 50.1604 18.7278Z",
  fill: "#F5F1E3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M62.5754 29.7859C63.9831 29.7859 65.1242 28.6447 65.1242 27.237C65.1242 25.8294 63.9831 24.6882 62.5754 24.6882C61.1678 24.6882 60.0266 25.8294 60.0266 27.237C60.0266 28.6447 61.1678 29.7859 62.5754 29.7859Z",
  fill: "#5E4537"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M53.6191 29.7859C55.0268 29.7859 56.1679 28.6447 56.1679 27.237C56.1679 25.8294 55.0268 24.6882 53.6191 24.6882C52.2115 24.6882 51.0703 25.8294 51.0703 27.237C51.0703 28.6447 52.2115 29.7859 53.6191 29.7859Z",
  fill: "#5E4537"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M71.5395 29.7859C72.9472 29.7859 74.0883 28.6447 74.0883 27.237C74.0883 25.8294 72.9472 24.6882 71.5395 24.6882C70.1319 24.6882 68.9907 25.8294 68.9907 27.237C68.9907 28.6447 70.1319 29.7859 71.5395 29.7859Z",
  fill: "#5E4537"
});

var SvgAppiconLifeSupports = function SvgAppiconLifeSupports(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppiconLifeSupports, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appicon-life-supports.f5f860d9.svg";
export { ForwardRef as ReactComponent };